<template>
  <div
    :class="[isSmile ? 'not-radial-smile' : 'not-radial', `dial-${color}`]"
    class="progress-animation"
    :data-progress="animatedPercentage"
  >
    <div class="inset">
      <div class="percentage">
        <div class="numbers">
          <span class="number">-</span>
          <div
            v-for="(_, i) in new Array(101).fill(0)"
            :key="i"
            class="number"
          >
            <span>
              {{ i }}%
            </span>
            <div
              v-if="isSmile"
              class="smile single"
              :class="goodness"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentSnapshotDial',

  props: {
    value: { type: Number, default: 0 },
    isSmile: { type: Boolean, default: false },
  },

  data() {
    return {
      animatedPercentage: 0,
    };
  },

  computed: {
    percentage() {
      return Math.round(this.value * 100);
    },

    color() {
      if (this.percentage >= 90) {
        return 'green';
      }
      if (this.percentage >= 50) {
        return 'blue';
      }
      return 'red';
    },

    goodness() {
      if (this.percentage >= 90) {
        return 'smile-good';
      }
      if (this.percentage >= 50) {
        return 'smile-near-good';
      }
      return 'smile-bad';
    },
  },

  watch: {
    percentage: {
      immediate: true,
      handler(newPercentage) {
        setTimeout(() => {
          this.animatedPercentage = newPercentage;
        }, 300);
      },
    },
  },
};
</script>

<style scoped lang="less">
.not-radial {
  @circle-size: 48px;
  @circle-color: @text-darkest;
  @inset-size: 48px;
  @inset-color: @white;
  @transition-length: 1s;
  @percentage-color: @text-darkest;
  @percentage-font-size: 36px;
  @percentage-text-width: 90px;

  margin: 0;
  width:  @percentage-text-width;
  height: @circle-size;

  &.dial-blue {
    .numbers {
      span {
        color: @jobscore-medium;
      }
    }
  }

  &.dial-green {
    .numbers {
      span {
        color: @jobscore-high;
      }
    }
  }

  &.dial-red {
    .numbers {
      span {
        color: @jobscore-very-low;
      }
    }
  }

  .inset {
    width:       @percentage-text-width;
    height:      @inset-size;
    //position:    absolute;
    margin-left: (@percentage-text-width - @percentage-text-width)/2;
    margin-top:  (@circle-size - @inset-size)/2;

    background-color: @inset-color;
    .percentage {
      height:   @inset-size;
      width:    @percentage-text-width;
      overflow: hidden;
      //position: absolute;
      top:      0;
      left:     0;

      .numbers {
        margin-top: -@inset-size;
        transition: width @transition-length;
        color:          @percentage-color;
        .number {
          width:          @percentage-text-width;
          display:        inline-flex;
          align-items: center;
          font-weight:    500;
          font-size:      @percentage-font-size;
          line-height: 48px;
        }
      }
    }
  }

  @i: 0;
  .loop (@i) when (@i <= 100) {
    &[data-progress="@{i}"] {
      .inset .percentage .numbers {
        width: @i * @percentage-text-width + @percentage-text-width;
      }
    }
    .loop(@i + 1);
  }
  .loop(@i);
}

.not-radial-smile {
  @circle-size: 48px;
  @circle-color: @text-darkest;
  @inset-size: 48px;
  @inset-color: @white;
  @transition-length: 1s;
  @percentage-color: @text-darkest;
  @percentage-font-size: 36px;
  @percentage-text-width: 150px;

  margin: 0;
  width:  @percentage-text-width;
  height: @circle-size;

  &.dial-blue {
    .numbers {
      span {
        color: @jobscore-medium;
      }
    }
  }

  &.dial-green {
    .numbers {
      span {
        color: @jobscore-high;
      }
    }
  }

  &.dial-red {
    .numbers {
      span {
        color: @jobscore-very-low;
      }
    }
  }

  .inset {
    width:       @percentage-text-width;
    height:      @inset-size;
    //position:    absolute;
    margin-left: (@percentage-text-width - @percentage-text-width)/2;
    margin-top:  (@circle-size - @inset-size)/2;

    background-color: @inset-color;
    .percentage {
      height:   @inset-size;
      width:    @percentage-text-width;
      overflow: hidden;
      //position: absolute;
      top:      0;
      left:     0;

      .numbers {
        margin-top: -@inset-size;
        transition: width @transition-length;
        color:          @percentage-color;
        .number {
          width:          @percentage-text-width;
          display:        inline-flex;
          align-items: center;
          font-weight:    500;
          font-size:      @percentage-font-size;
          line-height: 48px;
        }
      }
    }
  }

  .smile {
    margin: 0 0 0 8px;
  }

  @i: 0;
  .loop (@i) when (@i <= 100) {
    &[data-progress="@{i}"] {
      .inset .percentage .numbers {
        width: @i * @percentage-text-width + @percentage-text-width;
      }
    }
    .loop(@i + 1);
  }
  .loop(@i);
}
</style>
